export default __webpack_public_path__ + "static/media/marketplace_genesishouse.c612161b.png";